import { render } from "./IMarket.vue?vue&type=template&id=5706380a"
import script from "./IMarket.vue?vue&type=script&lang=js"
export * from "./IMarket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__